import { render } from "./dropZone.vue?vue&type=template&id=6ac24b06&scoped=true"
import script from "./dropZone.vue?vue&type=script&lang=js"
export * from "./dropZone.vue?vue&type=script&lang=js"

import "./dropZone.vue?vue&type=style&index=0&id=6ac24b06&scoped=true&lang=css"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac24b06"]])

export default __exports__